import ThemedSvgIcon from './ThemedSvgIcon';

const RelayIcon = (props) => (
    <ThemedSvgIcon {...props}>
        {(fill) => (
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_1816_313)">
                    <path
                        d="M19.8565 14.3259C20.9084 14.32 21.8198 14.8914 22.3077 15.7419L35.4717 15.6667C36.2573 15.6623 36.8883 16.2979 36.8838 17.0886C36.8793 17.8793 36.2407 18.5217 35.4551 18.5261L22.2911 18.6003C21.798 19.4564 20.8761 20.0387 19.8243 20.0447C18.2575 20.0536 16.9912 18.7779 17 17.2009C17.0091 15.624 18.2898 14.3348 19.8565 14.3259ZM19.834 16.116C19.5689 16.116 19.3145 16.2215 19.127 16.4089C18.9395 16.5964 18.8341 16.8508 18.834 17.116C18.834 17.3812 18.9395 17.6354 19.127 17.823C19.3145 18.0104 19.5689 18.116 19.834 18.116C20.0991 18.1159 20.3536 18.0104 20.5411 17.823C20.7284 17.6355 20.834 17.3811 20.834 17.116C20.834 16.8508 20.7285 16.5964 20.5411 16.4089C20.3536 16.2215 20.0991 16.116 19.834 16.116Z"
                        fill={fill}
                    />
                    <path
                        d="M6.02742 14.3259C4.97553 14.32 4.0641 14.8914 3.57625 15.7419L-9.58781 15.6667C-10.3734 15.6623 -11.0044 16.2979 -10.9999 17.0886C-10.9954 17.8793 -10.3568 18.5217 -9.57121 18.5261L3.59285 18.6003C4.08588 19.4564 5.00776 20.0387 6.05965 20.0447C7.62641 20.0536 8.89275 18.7779 8.88386 17.2009C8.8748 15.624 7.59408 14.3348 6.02742 14.3259ZM6.04988 16.116C6.31498 16.116 6.5694 16.2215 6.75691 16.4089C6.94442 16.5964 7.04985 16.8508 7.04988 17.116C7.04988 17.3812 6.94445 17.6354 6.75691 17.823C6.56939 18.0104 6.31504 18.116 6.04988 18.116C5.78479 18.1159 5.5303 18.0104 5.34285 17.823C5.15547 17.6355 5.04988 17.3811 5.04988 17.116C5.04991 16.8508 5.15541 16.5964 5.34285 16.4089C5.5303 16.2215 5.78479 16.116 6.04988 16.116Z"
                        fill={fill}
                    />
                    <path
                        d="M15.3502 6.18431L6.84691 14.5917L8.69369 16.4178L17.197 8.01039C17.7044 7.50867 17.7018 6.69531 17.191 6.19028C16.6803 5.68526 15.8577 5.68259 15.3502 6.18431Z"
                        fill={fill}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1816_313">
                        <rect width="25" height="25" fill={fill} />
                    </clipPath>
                </defs>
            </svg>
        )}
    </ThemedSvgIcon>
);

export default RelayIcon;
